import { render } from "./YoutubeUpdate.vue?vue&type=template&id=90ebcc54"
import script from "./YoutubeUpdate.vue?vue&type=script&lang=js"
export * from "./YoutubeUpdate.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__